/**
 * 权限相关 API
 */
import apiClient from './config';
import type { PermissionConfig } from '@/types/permission';

export interface UserPermissionsResponse {
  user_id: string;
  role: string;
  permissions: PermissionConfig[];
}

interface ApiResponse {
  success: boolean;
  data: UserPermissionsResponse;
}

/**
 * 获取当前用户的权限列表
 */
export async function getUserPermissions(): Promise<UserPermissionsResponse> {
  const response: ApiResponse = await apiClient.get('/user/permissions');
  if (!response.success || !response.data) {
    throw new Error('获取用户权限失败');
  }
  return response.data;
}
